import { render, staticRenderFns } from "./EmailRecipientSelector.vue?vue&type=template&id=f45d8296&"
import script from "./EmailRecipientSelector.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports